const getTestId = (id: string): string | undefined =>
    process.env.NODE_ENV === "test" || process.env.NODE_ENV === "development"
        ? id
        : undefined;
export default getTestId;
